import * as actionTypes from "../actionTypes";

export const getSecurityQuestions = () => {
  let query = "";
  return {
    type: actionTypes.GET_SECERUITY_QUE,
    query,
  };
};

export const saveProfileDetails = (payload) => {
  return {
    type: actionTypes.SAVE_PROFILE_DETAILS,
    payload,
  };
};

export const changePasswordDetails = (payload) => {
  return {
    type: actionTypes.CHANGE_PASSWORD_DETAILS,
    payload,
  };
};
